import * as $ from "jquery";

function initSpoutConfiguration() {
	
	$('body').on('click', '.js-s-prod-link', function(e){
		let $this = $(this).find('.state-selected');
		let imageToLoad = $this.data("imageid");
		let linksToLoad = $this.data("linksid");
		let primaryImage = $this.parents('.product-info-bar').find('.js-fs-primary-image');
		let links = $this.parents('.product-info-bar').find('.js-fs-links');
		let primaryDetail = $this.parents('.product-info-bar').find('.js-fs-primary-detail');
		let spoutImageUrl = $this.data("spouturl");
		let spoutDisplayName = $this.data("spoutdisplayname");
		let buyOnlineUrl = $this.data("buyonlineurl");
		//let handleImageUrl = $this.data("handleurl");
		
		$this.parents('.pfister-configuration').find('.product-spouturl').val(spoutImageUrl);
		$this.parents('.pfister-configuration').find('.product-spoutdisplayname').val(spoutDisplayName);
		//$this.parents('.pfister-configuration').find('.product-handleurl').val("handleImageUrl");
		
		$this.parents('.product-info-bar').find('.js-s-fs-link').removeClass('state-selected');
		$this.addClass('state-selected');

		primaryImage.removeClass('state-visible');
		links.removeClass('state-visible');
		primaryDetail.removeClass('state-visible');
		$this.parents('.pfister-configuration').find('.product-spout-highlight').removeClass('pfister-configuration__product-highlight');
		
		$this.parents('.product-info-bar').find(`#${imageToLoad}.js-fs-primary-image`).addClass('state-visible');
		$this.parents('.product-info-bar').find(`#${linksToLoad}`).addClass('state-visible');
		$this.parents('.product-info-bar').find(`#${imageToLoad}.js-fs-primary-detail`).addClass('state-visible');
		$this.parents('.product-spout-highlight').addClass('pfister-configuration__product-highlight');
		
		$this.parents('.pfister-configuration').find('.product-image').attr("src",spoutImageUrl+$this.parents('.pfister-configuration').find('.product-handleurl').val()+'?$PfisterConfig$');
		$this.parents('.pfister-configuration').find('.product-spout-displayname').html(spoutDisplayName);
		$this.parents('.pfister-configuration').find('.product-buyonlineurl').attr("href",buyOnlineUrl)
		e.preventDefault();
	})	
	$('body').on('click', '.js-s-fs-link', function(e){
		let $this = $(this);
		let imageToLoad = $this.data("imageid");
		let linksToLoad = $this.data("linksid");
		let primaryImage = $this.parents('.product-info-bar').find('.js-fs-primary-image');
		let links = $this.parents('.product-info-bar').find('.js-fs-links');
		let primaryDetail = $this.parents('.product-info-bar').find('.js-fs-primary-detail');
		let spoutImageUrl = $this.data("spouturl");
		let spoutDisplayName = $this.data("spoutdisplayname");
		let buyOnlineUrl = $this.data("buyonlineurl");
		//let handleImageUrl = $this.data("handleurl");
		
		$this.parents('.pfister-configuration').find('.product-spouturl').val(spoutImageUrl);
		$this.parents('.pfister-configuration').find('.product-spoutdisplayname').val(spoutDisplayName);
		//$this.parents('.pfister-configuration').find('.product-handleurl').val("handleImageUrl");
		
		$this.parents('.product-info-bar').find('.js-s-fs-link').removeClass('state-selected');
		$this.addClass('state-selected');

		primaryImage.removeClass('state-visible');
		links.removeClass('state-visible');
		primaryDetail.removeClass('state-visible');
		$this.parents('.pfister-configuration').find('.product-spout-highlight').removeClass('pfister-configuration__product-highlight');
		
		$this.parents('.product-info-bar').find(`#${imageToLoad}.js-fs-primary-image`).addClass('state-visible');
		$this.parents('.product-info-bar').find(`#${linksToLoad}`).addClass('state-visible');
		$this.parents('.product-info-bar').find(`#${imageToLoad}.js-fs-primary-detail`).addClass('state-visible');
		$this.parents('.product-spout-highlight').addClass('pfister-configuration__product-highlight');
		
		$this.parents('.pfister-configuration').find('.product-image').attr("src",spoutImageUrl+$this.parents('.pfister-configuration').find('.product-handleurl').val()+'?$PfisterConfig$');
		$this.parents('.pfister-configuration').find('.product-spout-displayname').html(spoutDisplayName);
		$this.parents('.pfister-configuration').find('.product-buyonlineurl').attr("href",buyOnlineUrl)
		e.preventDefault();
	})	
}

function initHandleConfiguration() {
	$('body').on('click', '.js-h-prod-link', function(e){
		let $this = $(this).find('.state-selected');
		let imageToLoad = $this.data("imageid");
		let linksToLoad = $this.data("linksid");
		let primaryImage = $this.parents('.product-info-bar').find('.js-fs-primary-image');
		let links = $this.parents('.product-info-bar').find('.js-fs-links');
		let primaryDetail = $this.parents('.product-info-bar').find('.js-fs-primary-detail');
		//let spoutImageUrl = $this.data("spouturl");
		let handleImageUrl = $this.data("handleurl");
		let handleDisplayName = $this.data("handledisplayname");
		
		//$this.parents('.pfister-configuration').find('.product-spouturl').val("spoutImageUrl");
		$this.parents('.pfister-configuration').find('.product-handleurl').val(handleImageUrl);
		$this.parents('.pfister-configuration').find('.product-handledisplayname').val(handleDisplayName);
		
		$this.parents('.product-info-bar').find('.js-h-fs-link').removeClass('state-selected');
		$this.addClass('state-selected');

		primaryImage.removeClass('state-visible');
		links.removeClass('state-visible');
		primaryDetail.removeClass('state-visible');
		$this.parents('.pfister-configuration').find('.product-handle-highlight').removeClass('pfister-configuration__product-highlight');
		
		$this.parents('.product-info-bar').find(`#${imageToLoad}.js-fs-primary-image`).addClass('state-visible');
		$this.parents('.product-info-bar').find(`#${linksToLoad}`).addClass('state-visible');
		$this.parents('.product-info-bar').find(`#${imageToLoad}.js-fs-primary-detail`).addClass('state-visible');
		$this.parents('.product-handle-highlight').addClass('pfister-configuration__product-highlight');
		
		$this.parents('.pfister-configuration').find('.product-image').attr("src",$this.parents('.pfister-configuration').find('.product-spouturl').val()+handleImageUrl+'?$PfisterConfig$');
		$this.parents('.pfister-configuration').find('.product-handle-displayname').html(handleDisplayName);
		e.preventDefault();
	})	
	
	$('body').on('click', '.js-h-fs-link', function(e){
		let $this = $(this);
		let imageToLoad = $this.data("imageid");
		let linksToLoad = $this.data("linksid");
		let primaryImage = $this.parents('.product-info-bar').find('.js-fs-primary-image');
		let links = $this.parents('.product-info-bar').find('.js-fs-links');
		let primaryDetail = $this.parents('.product-info-bar').find('.js-fs-primary-detail');
		//let spoutImageUrl = $this.data("spouturl");
		let handleImageUrl = $this.data("handleurl");
		let handleDisplayName = $this.data("handledisplayname");
		
		//$this.parents('.pfister-configuration').find('.product-spouturl').val("spoutImageUrl");
		$this.parents('.pfister-configuration').find('.product-handleurl').val(handleImageUrl);
		$this.parents('.pfister-configuration').find('.product-handledisplayname').val(handleDisplayName);
		
		$this.parents('.product-info-bar').find('.js-h-fs-link').removeClass('state-selected');
		$this.addClass('state-selected');

		primaryImage.removeClass('state-visible');
		links.removeClass('state-visible');
		primaryDetail.removeClass('state-visible');
		$this.parents('.pfister-configuration').find('.product-handle-highlight').removeClass('pfister-configuration__product-highlight');
		
		$this.parents('.product-info-bar').find(`#${imageToLoad}.js-fs-primary-image`).addClass('state-visible');
		$this.parents('.product-info-bar').find(`#${linksToLoad}`).addClass('state-visible');
		$this.parents('.product-info-bar').find(`#${imageToLoad}.js-fs-primary-detail`).addClass('state-visible');
		$this.parents('.product-handle-highlight').addClass('pfister-configuration__product-highlight');
		
		$this.parents('.pfister-configuration').find('.product-image').attr("src",$this.parents('.pfister-configuration').find('.product-spouturl').val()+handleImageUrl+'?$PfisterConfig$');
		$this.parents('.pfister-configuration').find('.product-handle-displayname').html(handleDisplayName);
		e.preventDefault();
	})	
}

function printFunctionalityInit() {
		$('.js-window-print').on('click', function(){
			$('.site-footer').hide();
			window.print();
			$('.site-footer').show();
		});
	}
export function init() {
	initSpoutConfiguration();
	initHandleConfiguration();
	printFunctionalityInit();
}



// WEBPACK FOOTER //
// ./js/PFF/modules/pfisterConfiguration.ts